export default __webpack_public_path__ + "static/media/icon-cities.a308ecdf.svg";